export const getStyleSheetByTitle = ( title : string ) : CSSStyleSheet | null => {
    let retVal : CSSStyleSheet | null = null;

    const styleSheets = document.styleSheets;

    for ( let i = styleSheets.length - 1; i >= 0; i-- ) {
        if ( styleSheets[ i ].title === title ) {
            retVal = styleSheets[ i ];
            break;
        }
    }

    return retVal;
}

export const getOrCreateStyleSheet = () : CSSStyleSheet | null => {
    return getOrCreateStyleSheetByTitle( 'dynamic_styles' );
}

export const getOrCreateStyleSheetByTitle = ( title : string ) : CSSStyleSheet | null => {
    let retVal : CSSStyleSheet | null = getStyleSheetByTitle( title );

    if ( !retVal ) {
        const styleSheet = document.createElement( 'style' );

        styleSheet.title = title;

        document.getElementsByTagName( 'head' )[ 0 ].appendChild( styleSheet );

        retVal = styleSheet.sheet;
    }

    return retVal;
}

export const ruleExists = ( styleSheet : CSSStyleSheet, ruleSelector : string ) : boolean => {
    let retVal = false;

    for ( const cssRule of styleSheet.cssRules as unknown as CSSStyleRule[] ) {
        if ( cssRule.selectorText === ruleSelector ) {
            retVal = true;
            break;
        }
    }

    return retVal;
}

export const appendRule = ( styleSheet : CSSStyleSheet, ruleSelector : string, ruleContent : string ) => {
    if ( styleSheet ) {
        styleSheet.insertRule( `${ruleSelector} ${ruleContent}`, styleSheet.cssRules.length );
    }
}

export const appendRuleIfNotExists = ( styleSheet : CSSStyleSheet, ruleSelector : string, ruleContent : string ) => {
    if ( styleSheet && !ruleExists( styleSheet, ruleSelector ) ) {
        styleSheet.insertRule( `${ruleSelector} ${ruleContent}`, styleSheet.cssRules.length );
    }
}
